import { useMemo } from "react";
import { Bar } from "react-chartjs-2";

import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Tooltip,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function ActivitiesByLawAreaChart({ data }) {
    const chartData = useMemo(() => {
        const sorted = [...data].sort(
            (a, b) => Number(b.total) - Number(a.total)
        );

        return {
            labels: sorted.map((item) => item.name),

            datasets: [
                {
                    label: "Atividades",
                    data: sorted.map((item) => Number(item.total)),
                    backgroundColor: 'rgba(90,180,232,0.25)',
                    borderColor: '#5ab4e8',
                    borderWidth: 1,
                    borderRadius: 4,
                },
            ],
        };
    }, [data]);

    const options = useMemo(
        () => ({
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: "x",
            plugins: {
                legend: { display: false, },
                tooltip: {
                    callbacks: {
                        label: (context) =>
                            `${context.raw} ${context.raw === 1 ? 'atividade' : 'atividades'}`,
                    },
                },

                datalabels: {
                    anchor: 'end',
                    align: "center",
                    color: "#0e0e0e",
                    clamp: true,
                    backgroundColor: '#5ab4e8',
                    borderRadius: 16,
                    font: {
                        weight: "bold",
                    },
                    formatter: (value) => `${value}`.padStart(2, '0'),
                },
            },


            scales: {
                x: { ticks: { color: '#4a7fa5', font: { size: 12 } }, grid: { color: 'rgba(255,255,255,0.04)' }, border: { color: 'rgba(255,255,255,0.06)' } },
                y: { ticks: { color: '#4a7fa5', font: { size: 16, weight: 'bold' } }, grid: { color: 'rgba(255,255,255,0.04)' }, border: { color: 'rgba(255,255,255,0.06)' } }
            }

        }),
        []
    );

    return (
        <div
            style={{
                height: Math.max(
                    data.length * 40,
                    400
                ),
            }}
        >
            <Bar
                data={chartData}
                options={options}
            />
        </div>
    );
}